import { render, staticRenderFns } from "./fixPW.vue?vue&type=template&id=521aa00c"
import script from "./fixPW.vue?vue&type=script&lang=js"
export * from "./fixPW.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports